// 统一请求路径前缀在commmon/axios.js中修改
import { getRequest, postRequest } from '../assets/js/api';

// 查询报告详情
export const _templateDetail = (id) => {
  return getRequest(`/api-report/report/invoke/preview?id=${id}`)
}

// 查询家长儿童报告记录
export const _templateList = (data) => {
  return postRequest(`/api-report/report/invoke/getReports`, data)
}

// 报告已读
export const _readTemplate = (data) => {
  return postRequest('/api-report/report/invoke/setReadedReports', data)
}